import { UsersPageThemeSizeConfig } from './types';

const small: UsersPageThemeSizeConfig = {
  usersPage: {},
};

export default small;
